import { getTMinus1, toISO8601 } from '@fortem-monorepo/js-utilities'
import { DialogProps } from '@fortem-monorepo/react-ui'
import { SubmitButton } from '@fortem-monorepo/react-ui'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@fortem-monorepo/react-ui'

import { RunDataExtractForm } from '@/components/forms/RunDataExtractForm/RunDataExtractForm'
import { RunDataExtractFormFields } from '@/components/forms/RunDataExtractForm/RunDataExtractFormFields'

export interface RunDataExtractModalProps extends DialogProps {}

export const RunDataExtractModal: React.FC<RunDataExtractModalProps> = ({ ...props }) => {
  return (
    <Dialog {...props}>
      <DialogContent>
        <RunDataExtractForm
          defaultValues={{ input_type: 'banks', report_date: toISO8601(getTMinus1()) }}
        >
          {({ formState: { isValid, isSubmitting } }) => {
            return (
              <>
                <DialogHeader>
                  <DialogTitle>Run Data Extract</DialogTitle>
                </DialogHeader>
                <div className="py-6">
                  <RunDataExtractFormFields />
                </div>
                <DialogFooter>
                  <SubmitButton
                    disabled={!isValid || isSubmitting}
                    loading={isSubmitting}
                    size="sm"
                  >
                    Submit
                  </SubmitButton>
                </DialogFooter>
              </>
            )
          }}
        </RunDataExtractForm>
      </DialogContent>
    </Dialog>
  )
}
